/// <amd-module name="Artifacts/Ivy/components/IvyPackagePeople" />
import { IvyXmlRef } from "Artifacts/Ivy/Contracts/Ivy";
import * as IvyRes from "Artifacts/Ivy/Resources";
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import { PackagePerson } from "Artifacts/Package/components/package-details-common/PackagePerson";
import { IPerson } from "Artifacts/Root/types/IPerson";
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IIvyPackagePeopleProps {
  pageContext: IVssPageContext;
  authors: IvyXmlRef[] | null;
}

export class IvyPackagePeople extends React.PureComponent<IIvyPackagePeopleProps> {
  public render(): JSX.Element {
    if (!this.props.authors) {
      return <div />;
    }

    return (
      <div className="ivy-package-people">
        <PackageAttribute title={IvyRes.IvyPackagePeople_Authors}>
          {this.props.authors.map((author: IvyXmlRef) => {
            return (
              <PackagePerson
                pageContext={this.props.pageContext}
                key={author.name}
                person={this.ToPerson(author)}
              />
            );
          })}
        </PackageAttribute>
      </div>
    );
  }

  private ToPerson(author: IvyXmlRef): IPerson {
    const href = author.url;
    const isEmail = href && href.indexOf("@") !== -1;
    return {
      name: author.name,
      email: isEmail ? href : null,
      url: isEmail ? null : href ? href : null,
    } as IPerson;
  }
}
